import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, LightbulbIcon, MessageCircleIcon, CalendarCheckIcon } from 'lucide-react';
export function ProductBreakdown() {
  const features = [{
    icon: <BookOpenIcon className="w-5 h-5 text-brand-slate" data-id="element-170" />,
    title: 'Fundamentos Claros',
    text: 'Fundamentos claros para entender qué significa Competir Sin Miedo y qué dice la evidencia.',
    image: 'https://cdn.magicpatterns.com/uploads/q2u4NzRayfkrVXAmvamSpe/WhatsApp_Image_2026-04-01_at_19.27.44.jpg'
  }, {
    icon: <LightbulbIcon className="w-5 h-5 text-brand-slate" data-id="element-171" />,
    title: 'Herramientas Mentales',
    text: 'Herramientas mentales clave: respiración, concentración, autodiálogo, visualización y confianza.',
    image: 'https://cdn.magicpatterns.com/uploads/we9c1HzxVzpkzmYp3FBPTN/WhatsApp_Image_2026-04-01_at_19.27.45.jpg'
  }, {
    icon: <MessageCircleIcon className="w-5 h-5 text-brand-slate" data-id="element-172" />,
    title: 'Estrategias Familiares',
    text: 'Estrategias para la familia: cómo apoyar sin invadir, comunicar mejor y ordenar el entorno.',
    image: 'https://cdn.magicpatterns.com/uploads/hgGvU1edbtDdXRk9DFq26P/WhatsApp_Image_2026-04-01_at_19.27.45c.jpg'
  }, {
    icon: <CalendarCheckIcon className="w-5 h-5 text-brand-slate" data-id="element-173" />,
    title: 'Plan de Acción',
    text: 'Un plan práctico de 30 días, checklists y hojas de trabajo para aplicar de inmediato.',
    image: 'https://cdn.magicpatterns.com/uploads/wwpQqriz1HucYt8n3qCHMP/WhatsApp_Image_2026-04-01_at_19.27.451.jpg'
  }];
  return <section className="py-20 md:py-28 bg-white" data-id="element-174">
      <div className="max-w-5xl mx-auto px-5 sm:px-6 lg:px-8" data-id="element-175">
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="text-center mb-12 md:mb-16" data-id="element-176">
          <h2 className="text-3xl md:text-4xl font-heading text-brand-slate leading-tight" data-id="element-177">
            Dentro de Competir sin Miedo vas a encontrar:
          </h2>
        </motion.div>

        <div className="space-y-12 lg:space-y-16" data-id="element-178">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4
        }} className={`flex flex-col ${index % 2 !== 0 ? 'md:flex-row-reverse' : 'md:flex-row'} items-center gap-8 lg:gap-12`} data-id="element-179">
              <div className="w-full md:w-1/2" data-id="element-180">
                <div className="aspect-video rounded-2xl overflow-hidden border border-gray-100" data-id="element-181">
                  <img src={feature.image} alt={feature.title} className="w-full h-full object-cover" loading="lazy" data-id="element-182" />
                </div>
              </div>

              <div className="w-full md:w-1/2 space-y-4" data-id="element-183">
                <div className="inline-flex items-center justify-center w-10 h-10 rounded-xl bg-[#f8f9fa] mb-2" data-id="element-184">
                  {feature.icon}
                </div>
                <h3 className="text-xl md:text-2xl font-heading text-brand-slate" data-id="element-185">
                  {feature.title}
                </h3>
                <p className="text-base md:text-lg text-brand-slate-light leading-relaxed" data-id="element-186">
                  {feature.text}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}